import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input } from "@angular/core";
import { IPropsPanicButtonModel } from "@shared/models/parking-line.model";
import { Icon } from "@types-custom/models/ui/icon-model";

@Component({
  selector: "sit-modal-panic-button",
  templateUrl: "./modal-panic-button.component.html",
  styleUrls: ["./modal-panic-button.component.scss"],
})
export class ModalPanicButtonComponent {
  @Input() properties: IPropsPanicButtonModel | undefined;

  readonly Icon = Icon;

  constructor(
    private httpClient: HttpClient,
    @Inject("environment") private environment: any,
  ) { }

  baseUrl = this.environment.postUrl;
}

